import React, { createContext, useState, useEffect, useContext } from 'react';

// 创建上下文
export const ThemeContext = createContext();

// 创建提供者组件
export const ThemeProvider = ({ children }) => {
  // 从本地存储初始化主题，默认为暗色主题
  const [darkMode, setDarkMode] = useState(() => {
    const savedTheme = localStorage.getItem('theme');
    return savedTheme ? savedTheme === 'dark' : true; // 默认为暗色主题
  });
  
  // 从本地存储初始化语言，默认为中文
  const [language, setLanguage] = useState(() => {
    const savedLanguage = localStorage.getItem('language');
    return savedLanguage || 'zh'; // 默认为中文
  });
  
  // 切换暗色/亮色主题
  const toggleTheme = () => {
    setDarkMode(!darkMode);
  };
  
  // 切换语言
  const toggleLanguage = () => {
    setLanguage(language === 'zh' ? 'en' : 'zh');
  };
  
  // 当主题变化时，更新本地存储和文档类
  useEffect(() => {
    localStorage.setItem('theme', darkMode ? 'dark' : 'light');
    
    // 更新文档根元素类，用于全局CSS变量切换
    if (darkMode) {
      document.documentElement.classList.add('dark-theme');
      document.documentElement.classList.remove('light-theme');
    } else {
      document.documentElement.classList.add('light-theme');
      document.documentElement.classList.remove('dark-theme');
    }
  }, [darkMode]);
  
  // 当语言变化时，更新本地存储
  useEffect(() => {
    localStorage.setItem('language', language);
  }, [language]);
  
  // 提供值对象
  const value = {
    darkMode,
    toggleTheme,
    language,
    toggleLanguage
  };
  
  return <ThemeContext.Provider value={value}>{children}</ThemeContext.Provider>;
};

// 自定义钩子，方便组件使用上下文
export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (context === undefined) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
}; 